export let gsapContext = gsap.context(() => {
});
let gsapMatchmedia;

import {swup} from "../script";
import disableScroll from "../libs/disable-scroll";
import {addVhMarkers} from './utils';

import('./smooth-scroll');

import {frontPageInit} from '../page-specific/front-page';
import {templateProjectInit} from '../page-specific/template-project';
import {templateCoCreationInit} from "../page-specific/template-co-creation";
import {templateCoCreationLoggedInit} from "../page-specific/template-co-creation-logged";
import {templateAboutInit} from "../page-specific/template-about";
import {templateMembershipInit} from "../page-specific/template-membership";
import {templateRedeemNftInit} from "../page-specific/template-redeem-nft";
import {templateArchiveInit} from "../page-specific/template-archive";
import {templateTrophyRoomInit} from "../page-specific/template-trophy-room";
import {templateExperienceInit} from "../page-specific/template-experience";
import {singleProductInit} from "../page-specific/single-product";
import {yourVotesInit} from "../page-specific/your-votes";

import {inputToToggle} from "./custom-checkbox-radio";
import {closePopupById, initPopups} from './popups';
import {initAccordions} from './toggle-accordion';
import {TypeShuffle} from "../libs/typeShuffle";
import {bindLinkToItem} from "./bind-link-to-item";


export function initThemeScripts() {

	const body    = document.body;
	const content = document.getElementById('content');
	const footer  = document.getElementById('site-footer');


	const nebulaLinks = document.querySelectorAll('.nebula-menu a');

	nebulaLinks.forEach((element) => {
		element.style.minWidth = element.offsetWidth + 'px';

		const ts = new TypeShuffle(element);
		ts.trigger('fx1');

		element.addEventListener('mouseenter', function () {
			ts.trigger('fx1');
		});
	});

	const web3ProviderBtn = document.getElementById('web3-provider-btn');

	if (web3ProviderBtn)
	{
		web3ProviderBtn.addEventListener('click', function (e) {
			e.preventDefault();

			closePopupById('login-popup');

			connectWeb3Browser(web3ProviderBtn.dataset.connect);

			return false;
		});
	}

	const walletconnectProviderBtn = document.getElementById('walletconnect-provider-btn');

	if (walletconnectProviderBtn)
	{
		walletconnectProviderBtn.addEventListener('click', function (e) {
			e.preventDefault();

			closePopupById('login-popup');

			connectWalletConnect(walletconnectProviderBtn.dataset.connect);

			return false;
		});
	}

	const coinbaseProviderBtn = document.getElementById('coinbase-provider-btn');

	if (coinbaseProviderBtn)
	{
		coinbaseProviderBtn.addEventListener('click', function (e) {
			e.preventDefault();

			closePopupById('login-popup');

			connectCoinbaseWallet(coinbaseProviderBtn.dataset.connect);

			return false;
		});
	}


	gsap.registerPlugin(ScrollTrigger);


	if (body.classList.contains('page-template-template-project'))
	{
		templateProjectInit();
	}

	if (body.classList.contains('page-template-template-co-creation'))
	{
		templateCoCreationInit();
	}

	if (body.classList.contains('page-template-template-co-creation-logged'))
	{
		templateCoCreationLoggedInit();
	}

	if (body.classList.contains('page-template-template-about'))
	{
		templateAboutInit();
	}

	if (body.classList.contains('page-template-template-membership'))
	{
		templateMembershipInit();
	}

	if (body.classList.contains('page-template-template-redeem-nft'))
	{
		templateRedeemNftInit();
	}

	if (body.classList.contains('page-template-template-archive'))
	{
		templateArchiveInit();
	}

	if (body.classList.contains('page-template-template-trophy-room'))
	{
		templateTrophyRoomInit();
	}

	if (body.classList.contains('page-template-template-experience'))
	{
		templateExperienceInit();
	}

	if (body.classList.contains('page-home'))
	{
		frontPageInit();
	}

	if (body.classList.contains('single-product'))
	{
		singleProductInit();
	}

	if (body.classList.contains('woocommerce-your-votes'))
	{
		yourVotesInit();
	}


	/**
	 * Add markers every 100vh (comment to disable)
	 */
	//addVhMarkers();

	inputToToggle('input[type=checkbox].toggle, input[type=radio].toggle, .gfield.toggle input[type=checkbox]');

	/**
	 * Animations for footer
	 */
	if (!body.classList.contains('page-home') && footer !== null)
	{
		gsapContext.add(() => {

			gsapMatchmedia = gsap.matchMedia();

			gsapMatchmedia.add({
				isDesktop: '(min-width: 992px)',
				isTablet:  '(min-width: 768px) and (max-width: 991.98px)',
				isMobile:  '(max-width: 767.98px)'

			}, (context) => {

				let {isDesktop, isTablet, isMobile} = context.conditions;

				ScrollTrigger.create({
					trigger:             footer,
					start:               isMobile ? 'top 75%' : 'top 50%',
					end:                 isMobile ? '' : '+=100%',
					invalidateOnRefresh: true,
					onToggle:            ({progress, direction, isActive}) => {
						if (isActive)
						{
							setTimeout(function () {
								footer.classList.add('trigger-1');
							}, 500)

							if (!isMobile)
							{
								body.classList.add('footer-active');
							}
						}
						else
						{
							footer.classList.remove('trigger-1');

							if (!isMobile)
							{
								body.classList.remove('footer-active');
							}
						}
					},
					//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
				});

			});

		});
	}


	// triggers right before the content of page is replaced
	swup.off('willReplaceContent', killGsapAnimations);
	swup.on('willReplaceContent', killGsapAnimations);

	function killGsapAnimations() {

		if (typeof gsapContext !== 'undefined')
		{
			gsapContext.revert();
		}

		if (typeof gsapMatchmedia !== 'undefined')
		{
			gsapMatchmedia.revert();
		}
	}

	/**
	 * Modal buttons
	 * @type {NodeListOf<Element>}
	 */
	let modalButtons    = document.querySelectorAll('[data-modal-id]');
	let modalContainers = document.querySelectorAll('.modal-sketch');

	modalButtons.forEach((el, i) => {

		el.addEventListener('click', function () {
			let modalId = this.getAttribute('data-modal-id');
			let modal   = document.getElementById(modalId);

			if (modal !== null)
			{
				modal.classList.add('modal-sketch--open');
			}
		});

	});


	modalContainers.forEach((el, i) => {

		let toggleVideo = el.querySelector('.toggle-video');

		if (toggleVideo !== null)
		{
			toggleVideo.addEventListener('click', function () {
				let videoId = this.getAttribute('data-video-id');
				let video   = document.getElementById(videoId);

				if (video !== null)
				{
					let videoModal = video.closest('.modal-sketch');

					if (videoModal.classList.contains('video-open'))
					{
						videoModal.classList.remove('video-open');
						video.removeAttribute('controls');
						video.removeAttribute('autoplay');
						video.removeAttribute('playsinline');
						video.pause();
						video.currentTime = 0;
						video.load(); // show poster
						body.classList.remove('video-open');

						disableScroll.off(); // re-enable scroll

						let videoUnderlay = document.querySelector('.video-underlay');
						videoUnderlay.remove();
					}
					else
					{
						videoModal.classList.add('video-open');
						video.setAttribute('controls', '');
						video.setAttribute('autoplay', '');
						video.setAttribute('playsinline', '');
						video.play();
						body.classList.add('video-open');

						disableScroll.on(); // prevent scrolling

						let videoUnderlay = document.createElement('div');
						videoUnderlay.classList.add('video-underlay');
						videoModal.before(videoUnderlay);
					}
				}
			});
		}

	});


	/**
	 * Force ALL ScrollTrigger instances to re-calculate its start and end values after each image is loaded
	 */
	let images = content.querySelectorAll('img');

	Promise.all(Array.from(images).map(img => {

		if (img.complete)
		{
			return Promise.resolve(img.naturalHeight !== 0);
		}

		return new Promise(resolve => {

			img.addEventListener('load', () => {

				// refresh here
				ScrollTrigger.refresh();

				resolve(true);
			});

			img.addEventListener('error', () => resolve(false));

		});

	})).then(results => {

		if (results.every(res => res))
		{
			//console.log('all images loaded successfully');
		}
		else
		{
			//console.log('some images failed to load, all finished loading');
		}

	});


	/**
	 * Init popups
	 */
	initPopups();


	/**
	 * Init accordions
	 */
	initAccordions();


	/**
	 * Bind link to items
	 */
	bindLinkToItem('.link-all-item');


	/**
	 * ON LOAD
	 */

	window.addEventListener('load', function (event) {


	});



	/**
	 * ON RESIZE
	 */

	window.addEventListener('resize', function (event) {
		if (event.target === window)
		{
			// trigger resizeEnd event only when the window resizing ends
			if (this.resizeTO)
			{
				clearTimeout(this.resizeTO);
			}
			this.resizeTO = setTimeout(function () {
				const event = new CustomEvent('resizeEnd');
				window.dispatchEvent(event);
			}, 200);
		}
	});



	/**
	 * ON RESIZE END
	 */

	// do something when the window resizing ends
	window.addEventListener('resizeEnd', function () {

		ScrollTrigger.getAll().forEach(t => t.refresh());

	});



	/**
	 * ON SCROLL
	 */
	/*window.addEventListener('scroll', function() {
	});*/

}



